import { LegacyRef } from "react";
import LoadingSpinner from "../LoadingSpinner";
import ChatMessageBox from "./ChatMessageBox";
import ChatMessagesList, {
  ChatMessage,
  ChatMessagesGroup,
} from "./ChatMessagesList";

export type ChatConversationViewProps = {
  isLoadingMessages: boolean;
  messageGroups: ChatMessagesGroup;
  onMessageChange: (value: string) => void;
  onSendDraftMessage: () => void;
  draftMessage?: string;
  messageBoxInputRef: LegacyRef<HTMLTextAreaElement>;
};

export default function ChatConversationView(props: ChatConversationViewProps) {
  const {
    messageGroups,
    onMessageChange,
    onSendDraftMessage,
    draftMessage,
    isLoadingMessages,
    messageBoxInputRef,
  } = props;
  const onSelectFile = (file: File | undefined) => {};

  if (isLoadingMessages) {
    return (
      <div className="w-full h-full flex justify-center items-center">
        <LoadingSpinner size={100} />
      </div>
    );
  }

  return (
    <div className="relative">
      <div
        className="relative h-[calc(100vh-250px)] overflow-y-auto md:h-[calc(100vh-275px)]"
        style={{ height: "" }}
      >
        <ChatMessagesList messageGroups={messageGroups} />
      </div>
      <ChatMessageBox
        onMessageChange={onMessageChange}
        onSelectFile={onSelectFile}
        onSendDraftMessage={onSendDraftMessage}
        draftMessage={draftMessage}
        messageBoxInputRef={messageBoxInputRef}
      />
    </div>
  );
}
